module.exports = __webpack_public_path__ + "img/LeastDiscontent.0da4d869.png";